import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingX: 3,
    paddingY: 3,
  },
  personCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    padding: 2,
    border: '1px solid',
    borderColor: 'gray.12',
    borderRadius: 2,
    backgroundColor: 'background.paper',
  },
  personInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    flexGrow: 1,
  },
  personHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    width: '100%',
  },
  equipmentChipContainer: {
    marginLeft: 1,
    width: 'fit-content',
  },
  optionCard: {
    border: '1px solid',
    borderColor: 'gray.24',
    borderRadius: 2,
    padding: 2,
  },
  fieldsRow: {
    display: 'grid',
    gridTemplateColumns: '208px 208px',
    columnGap: 2,
    rowGap: 2,
    width: 'fit-content',
  },
  delayFieldFull: {
    gridColumn: '1 / -1',
  },
  infoBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    paddingY: 1.25,
    paddingX: 2,
    borderRadius: 1,
    backgroundColor: 'gray.3',
    color: 'gray.80',
  },
  radioGroup: {
    display: 'grid',
    gridTemplateColumns: '208px 208px',
    columnGap: 2,
    rowGap: 0,
    width: 'fit-content',
  },
  radioLabel: {
    fontWeight: 600,
    marginTop: 1,
    color: 'gray.80',
  },
  radioButton: {
    width: 208,
  },
  sessionTypeField: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
}
